<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" :absolute="false" />

    <v-row no-gutters>
      <v-col
        v-for="(paslauga, paslaugaIndex) in paslaugosFiltered"
        :key="`paslauga-${paslaugaIndex}`"
        cols="12"
        md="12"
        class="mb-3"
      >
        <h3 class="mt-3 mb-2">
          {{ paslauga.groupTitle
          }}<el-tooltip
            inline
            :tooltip="paslauga.tooltip"
            external
            @activate="
              eventPayload => showAprasymas(eventPayload, paslauga.tooltip)
            "
          />
        </h3>
        <div
          class="paslauga-aprasymas mb-2"
          v-if="paslaugaAprasymas === paslauga.tooltip"
        >
          <el-paslauga-aprasymas
            :key="`paslauga.groupTitle`"
            :tooltip="paslaugaAprasymas"
            @close="hideAprasymas"
          />
        </div>

        <v-card class="ntr-card-gray pt-2 py-2 px-2" flat>
          <v-row no-gutters>
            <v-col
              v-for="pazyma in paslauga.pazymaList"
              :key="pazyma.key"
              cols="12"
              md="6"
              class="mb-2 px-2 pt-2"
            >
              <el-savitarna-icon
                class="prasymas-icon mr-2"
                :icon="pazyma.icon"
                :title="pazyma.title"
                type="ntrpaslauga"
                :loading="loading"
                @click.native="gotopazyma(pazyma)"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'

export default {
  name: 'PazymosMeniu',
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      paslaugaAprasymas: null,
    }
  },
  computed: {
    ...mapGetters(['savitarnaRedirect']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    savitarnaPrefix() {
      return `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}`
    },
    savitarnaParams() {
      return ''
    },
    paslaugosList() {
      return [
        {
          groupTitle: this.$t(
            'NTR duomenys apie asmens turimą žemės ūkio / miškų ūkio paskirties žemę'
          ),
          pazymaList: [
            {
              meniuId: 1,
              title: this.$t('Pažyma apie žemės ūkio paskirties žemę'),
              route: 'pazymosZemesUkio',
              icon: 'mdi-tractor-variant',
              roles: this.roleOr(['EL_FA', 'EL_JA', 'EL_igaliotinis']),
            },
            {
              meniuId: 2,
              title: this.$t('Pažyma apie miškų ūkio paskirties žemę'),
              route: 'pazymosMiskuUkio',
              icon: 'mdi-forest-outline',
              roles: this.roleOr(['EL_FA', 'EL_JA', 'EL_igaliotinis']),
            },
          ],
        },
      ]
    },
    paslaugosFiltered() {
      return this.paslaugosList.filter(paslauga => {
        paslauga.tooltip = `NtrPaslaugos. ${paslauga.groupTitle}. Meniu. Anotacija`
        paslauga.pazymaList = paslauga.pazymaList.filter(pazyma => {
          return !pazyma.hide && pazyma.roles && pazyma.meniuId > 0
        })
        return !paslauga.hide && paslauga.pazymaList.length > 0
      })
    },
  },
  created() {
    this.pageloading = false
    this.loading = false
    this.checkRedirect()
  },
  methods: {
    checkRedirect() {
      if (this.savitarnaRedirect) {
        const redirect = this.savitarnaRedirect
        this.$store
          .dispatch('savitarnaRedirect', null)
          .then(this.$router.push({ name: redirect }))
      }
    },
    gotoLocal(route) {
      this.$router.push({ name: route })
    },
    gotopazyma(pazyma) {
      this.$store.dispatch('pazymaTipas', pazyma.paz_tipas).then(() => {
        this.$router.push({ name: pazyma.route })
        // window.location.href = `${this.savitarnaPrefix}goto.do?menuId=${pazyma.meniuId}`
      })
    },
    showAprasymas(tipas) {
      this.paslaugaAprasymas = tipas
    },
    hideAprasymas() {
      this.paslaugaAprasymas = null
      this.$store.dispatch('activeTooltip', '')
    },
  },
}
</script>
<style lang="scss" scoped>
.pazyma-icon {
  height: 100%;

  &:hover {
    cursor: pointer;
    background: #e5e5e5;
  }
}
</style>
